module.exports = __webpack_public_path__ + "img/pos-icon.944bb9ce.svg";